import { render, staticRenderFns } from "./forgetPwd.vue?vue&type=template&id=560ec6c0&scoped=true"
import script from "./forgetPwd.vue?vue&type=script&lang=js"
export * from "./forgetPwd.vue?vue&type=script&lang=js"
import style0 from "./forgetPwd.vue?vue&type=style&index=0&id=560ec6c0&lang=scss"
import style1 from "./forgetPwd.vue?vue&type=style&index=1&id=560ec6c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560ec6c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('560ec6c0')) {
      api.createRecord('560ec6c0', component.options)
    } else {
      api.reload('560ec6c0', component.options)
    }
    module.hot.accept("./forgetPwd.vue?vue&type=template&id=560ec6c0&scoped=true", function () {
      api.rerender('560ec6c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/forgetPwd.vue"
export default component.exports